import { useCallback } from 'react'
import {
  createCodeInjection, createManyCodeInjections
} from '@src/lib/apiClient'
import { UnpauseWithResyncToast, PauseToast, SaveChangesToast } from '@src/components/MediaPlayerControlToasts'
import toast from 'react-hot-toast'

export type ControlTarget = {
  type: 'work' | 'mediaplayer' | 'exhibition';
  id: number;
}

export const issueCommands = (target: ControlTarget, code: string) => {
  switch (target.type) {
    case 'mediaplayer':
      createCodeInjection({
        type: 'command',
        code,
        mediaPlayerId: target.id,
      })
      break
    case 'work':
      createManyCodeInjections({
        type: 'command',
        code,
        workId: target.id,
      })
      break
    case 'exhibition':
      createManyCodeInjections({
        type: 'command',
        code,
        exhibitionId: target.id,
      })
      break
    default:
      // todo
      // throw ('This should be unreachable')
      break
  }
}

const useMediaPlayerControls = (target: ControlTarget) => {
  const handleMediaPlayerControlClick = useCallback((code: string) => {
    issueCommands(target, code)

    if (code === 'pause') {
      toast(PauseToast, { id: 'transport' })
    }
    if (code === 'playResync') {
      toast(UnpauseWithResyncToast, { id: 'resync' })
    }
    if (['nudgeUp', 'nudgeDown', 'nudgeLeft', 'nudgeRight', 'stretchX', 'stretchY', 'compresesX', 'compressY', 'enlarge', 'shrink'].includes(code)) {
      toast(SaveChangesToast, { id: 'move' })
    }
  }, [target])

  return {
    handleMediaPlayerControlClick,
  }
}

export default useMediaPlayerControls
